<template>
  <el-tour v-model="open" @finish="onFinish">
    <el-tour-step v-for="(step, index) in steps" :key="index" :target="step.target" :title="step.title"
      :description="step.content" :placement="step.placement" />
  </el-tour>
</template>

<script setup>

import useUsuarioStore from '@/store/usuario';

const swal = inject('swal');
const route = useRoute();
const open = ref(false);
const steps = ref([]);
const currentTourKey = ref('');
const usuario_store = useUsuarioStore();

// Dynamically import all json files in the tours directory
const tours = import.meta.glob('@/tours/*.json');

const checkAndStartTour = async () => {
  let routeName = route.name;
  if (!routeName) return;

  if (routeName === 'home') {
    if (usuario_store.isCliente) routeName = 'home.cliente';
    else if (usuario_store.isPromotor) routeName = 'home.promotor';
    else if (usuario_store.isAdmin) routeName = 'home.admin';
  }

  // Find the matching tour file for the current route
  let matchedPath = null;
  for (const path in tours) {
    // Check if the file name matches the route name
    // path format is like /src/tours/home.json or ../tours/home.json
    const fileName = path.split('/').pop().replace('.json', '');
    if (fileName === routeName) {
      matchedPath = path;
      break;
    }
  }

  if (!matchedPath) return;

  const tourKey = `tour_completed_${routeName}`;
  currentTourKey.value = tourKey;

  // Check if user has already made a decision
  if (localStorage.getItem(tourKey)) {
    return;
  }

  try {
    // Load tour data
    const mod = await tours[matchedPath]();
    if (mod && mod.default && mod.default.steps && mod.default.steps.length > 0) {
      steps.value = mod.default.steps;

      // Ask user if they want to take the tour
      swal({
        title: '¿Te gustaría realizar un tour?',
        text: "Te enseñaremos las funcionalidades de esta sección.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, empezar',
        cancelButtonText: 'No, gracias'
      }).then(({ isConfirmed, isDismissed, }) => {
        if (isConfirmed) {
          // Start tour logic
          // We need to wait a bit to ensure elements are rendered?
          // The elements should be there as the route is loaded.
          open.value = true;
        }

        if (isDismissed) {
          localStorage.setItem(tourKey, 'declined');
        }
      });
    }
  } catch (e) {
    console.error("Error loading tour:", e);
  }
};

onMounted(() => {
  // Initial check with a small delay to ensure page content is mounted
  // setTimeout(checkAndStartTour, 1500);
});

watch(
  () => route.name,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      open.value = false;
      setTimeout(checkAndStartTour, 1500);
    }
  }
);

const onFinish = () => {
  localStorage.setItem(currentTourKey.value, 'completed');
  open.value = false;
};


// If the user closes the tour by clicking outside or the close button,
// we currently don't mark it as 'completed' so they might see it next time?
// Or should we consider it declined/done? 
// For now, only explicit finish marks as completed, 
// OR specific decline in Swal marks as declined.
</script>
